import styles from './Badge.module.scss'

/**
 * Small circular counter badge to overlay on icons or buttons.
 *
 * Visibility is controlled by CSS (`visibility: hidden` when count is 0)
 * rather than conditional rendering, so the badge always occupies space in
 * the layout. This prevents the parent element from shifting when the count
 * appears or disappears.
 *
 * The badge is unstyled regarding position — callers are responsible for
 * placing it (typically `position: absolute` on the badge with
 * `position: relative` on the trigger wrapper).
 *
 * @param {object}  props
 * @param {number}  props.count              - current count; 0 = badge hidden
 * @param {number}  [props.max=99]           - counts above max display as "max+"
 * @param {string}  [props.className]        - extra class merged onto root element
 */
export function Badge({ count, max = 99, className }) {
  const displayCount = count > max ? `${max}+` : `${count}`
  const isVisible    = count > 0

  return (
    <span
      className={[styles.badge, className].filter(Boolean).join(' ')}
      style={{ visibility: isVisible ? 'visible' : 'hidden' }}
      aria-label={isVisible ? `${count}` : undefined}
      aria-hidden={!isVisible}
    >
      {displayCount}
    </span>
  )
}
